import {
  defaultNewMemo,
  filterSubType,
  infoStepType,
  MemoAcceptData,
  MemoCategory,
  MemoPriority,
  MemoResendData,
  memoType,
  MemoTypeData,
  NewMemoCategory,
  PersonalMemoData,
  progressType,
  steps,
  storeType,
  StudentMemoTypeData
} from "./communications-types";
import {HttpClient} from "@angular/common/http";
import {SettingsService} from '../settings/settings.service';
import {Observable, of} from "rxjs";
import {map} from "rxjs/operators";
import {EventEmitter} from "@angular/core";

export class DataSource {

  store: storeType = {
    network: {},
    memos: [],
    studentMemos: [],
    memo: new memoType(defaultNewMemo),
    searchResults: [],
    filteredResults: [],
    filters: {
      category: {type: "checkmark", data: []},
      priorities: {type: "checkmark", data: []},
      sent: {
        type: "checkmark", data: [
          {name: "Sent", memoID: 0, networkId: 0, value: "1"},
          {name: "Not Sent", memoID: 0, networkId: 0, value: "0"}
        ]
      },
      status: {
        type: "dropdown", data: [
          {name: "Select Status", memoID: 0, networkId: 0, value: ""},
          {name: "Archived", memoID: 0, networkId: 0, value: "1"},
          {name: "Active", memoID: 0, networkId: 0, value: "0"}
        ]
      },

    },
    progress: {
      title: steps.create.title,
      text: steps.create.text
    },
    currentInfoText: {title: "", text: ""},
    confirmation: [{name: "", memoID: 0, networkId: 0}],
    groupMemosIntoCategories: [],
    selectedForReSendMemos: new Set()
  };
  public categoryGroupsAndCountEmitter = new EventEmitter();
  private _allMemosUrl: string = "/memos/getMemos.json";
  private _removeMemoUrl: string = "";
  private _viewMemoByIdUrl: string = "/memos/view"
  private _filterQueryStringUrl = "/memos/index?"
  private setArchiveUrl = '/memos/setArchive.json';

  private readonly fetchAllCategoriesUrl = '/memos/getCategories.json';
  private readonly fetchAllPrioritiesUrl = '/memos/getPriorities.json';
  private readonly fetchAllconfirmationMessagesUrl = '/memos/getConfirmationMessages.json';

  private readonly createCategoriesUrl = '/memos/createCategories.json';
  private readonly createPrioritiesUrl = '/memos/createPriorities.json';
  private readonly deleteItemUrl = '/memos/delete/';

  private updatePrioritiesUrl = "/memos/updatePriorities.json"
  private updateCategoriesUrl = "/memos/updateCategories.json"

  private readonly saveMemoUrl = '/memos/save.json';
  private readonly saveConfirmationMessagesUrl = '/networks/updateNetworkMemoConfirmationText.json';
  private readonly resendMemosUrl = '/memos/resendMemos.json';

  private readonly readMemoUrl = '/memos/readMemo/';
  private readonly acceptMemoUrl = '/memos/acceptMemo.json';

  private readonly getPersonalMemosUrl = '/memos/getPersonalMemos.json';

  private cachedMemoPriorities: MemoPriority[] = null;
  private cachedMemoCategories: MemoCategory[] = null;
  private mappedMemoPriorities: Map<number, MemoPriority> = new Map<number, MemoPriority>();
  private mappedMemoCategories: Map<number, MemoCategory> = new Map<number, MemoCategory>();
  private categoryGroupsAndCount = [];

  constructor(private _http?: HttpClient, private SettingsService?: SettingsService) {
    this.setupMemoCategories();
    this.setupMemoPriorities();
  };

  fetchAllMemos(callback, purge?: boolean) {
    if (this.store.memos.length == 0 || purge) {
      this._http.get<Array<memoType>>(this._allMemosUrl).subscribe((memos) => {

        let sortedMemos = memos.sort((a, b) => {
          return (new Date(b.Memo.dateCreated) as any) - (new Date(a.Memo.dateCreated) as any)
        })

        Object.assign(this.store.memos, sortedMemos);

        if (this.store.filters.category.data.length > 0) {
          this.populateMemoCategories()
        }
        callback(this.store.memos);
      })
    } else {
      callback(this.store.memos);
    }
  }

  fetchFilterMemos(query, callback) {
    switch (query) {
      case 'archived' : {
        this.setFilteredResults(this.store.memos.filter((e) => e.Memo.archive == true));
        callback()
      }
        break;
      case 'all' : {

        this._http.get<Array<memoType>>(this._allMemosUrl).subscribe((m) => {
          let sortedMemos = m.filter((m) => m.Memo.archive == false).sort((a, b) => {
            return (new Date(b.Memo.dateCreated) as any) - (new Date(a.Memo.dateCreated) as any)
          })
          this.setFilteredResults(sortedMemos);
          callback()
        })
      }
        break;
      case 'sent' : {
        this.setFilteredResults(this.store.memos.filter((e) => e.Memo.sent == 1 && e.Memo.archive != 1));
        callback()
      }
        break;
      case 'unsent' : {
        this.setFilteredResults(this.store.memos.filter((e) => e.Memo.sent != 1 && e.Memo.archive != 1));
        callback()
      }
    }

  }

  getPriorityName(id: number) {
    let priority = this.mappedMemoPriorities.get(id);

    if (priority) return priority.priority;
    else return 'Unknown priority';
  }

  getCategoryName(id: number) {
    let category = this.mappedMemoCategories.get(id);

    if (category) return category.category;
    else return 'Unknown category';
  }

  getAllPersonalMemos(callback, purge?: boolean) {
    // if (this.store.memos.length == 0 || purge) {

    this._http.get<PersonalMemoData[]>(this.getPersonalMemosUrl).subscribe((memos) => {

      let flatmemos = memos.map((m) => {

        m["Memo"]["status"] = m["MemoUserLink"]["readStatus"];
        m["Memo"]["dateSent"] = m["MemoUserLink"]["dateSent"];
        m["Memo"]["priority"] = this.getPriorityName(m["Memo"]["priorityID"]); //this.store.filters.priorities.data.filter((p)=>p.id == m["Memo"]["priorityID"])[0].name;
        m["Memo"]["category"] = this.getCategoryName(m["Memo"]["categoryID"]); //this.store.filters.category.data.filter((c)=>c.id == m["Memo"]["categoryID"])[0].name

        return m["Memo"];
      })

      let sortedMemos = flatmemos.sort((a, b) => {
        return (new Date(b.dateSent) as any) - (new Date(a.dateSent) as any)
      });

      Object.assign(this.store.studentMemos, sortedMemos);

      // if (this.store.filters.category.data.length > 0 ) this.populateMemoCategories();

      callback(sortedMemos);
    })
    // } else {
    //   callback(this.store.memos);
    // }
  }

  fetchNetworkSettings(callback) {

    this.SettingsService.getSettings().subscribe((n) => {
      this.store.network = n;

      // this.store.memo.Memo.address = `${n['Network']['network_name']}\n${n['Network']['network_address']}\n${n['Network']['network_city']} ${n['Network']['network_state']} ${n['Network']['network_zip']} `
      this.store.memo.Memo.logo = n.Network.corporate_logo;

      if (n['Network']) {

        // this.model.logo.value = n['Network'].corporate_logo;
      }

      callback(this.store.network)
    })
  }

  fetchAllconfirmationMessages(callback?) {
    this._http.get<string[]>(this.fetchAllconfirmationMessagesUrl).subscribe(confirmationMessages => {
      let confirm = confirmationMessages.map(message => {
        return {name: message, networkId: null, id: null, memoID: null};
      });

      if (!confirm.some((f) => f.name == 'I have read and accepted this memo')) {
        confirm.unshift({name: "I have read and accepted this memo", networkId: null, id: null, memoID: null})
      }
      Object.assign(this.store.confirmation, confirm);
      if (callback){
        callback(confirm);
      }

    })

  }

  memoCategoriesLoaded() {
    return this.cachedMemoCategories !== null;
  }

  memoPrioritiesLoaded() {
    return this.cachedMemoPriorities !== null;
  }

  getMemoCategory(categoryId: number) {
    return this.mappedMemoCategories.get(categoryId);
  }

  getMemoPriority(priorityId: number) {
    return this.mappedMemoPriorities.get(priorityId);
  }

  getCachedMemoPriorities() {
    if (this.cachedMemoPriorities === null) {
      return this.fetchAllPriorities().pipe(
        map(priorities => {
          this.cachedMemoPriorities = priorities;
          priorities.forEach(priority => this.mappedMemoPriorities.set(priority.priorityID, priority));

          return priorities;
        })
      );
    } else {
      return of(this.cachedMemoPriorities);
    }
  }

  fetchAllPriorities(): Observable<MemoPriority[]> {
    return this._http.get<MemoPriority[]>(this.fetchAllPrioritiesUrl);
  }

  setupMemoPriorities() {
    this.getCachedMemoPriorities().subscribe(priorities => {
      let filterTypes: filterSubType[] = priorities.map(priority => {
        return {
          name: priority.priority,
          memoID: 0,
          networkId: priority.networkID,
          id: priority.priorityID
        };
      });

      Object.assign(this.store.filters.priorities.data, filterTypes);
    });
  }

  getCachedMemoCategories() {
    if (this.cachedMemoCategories === null) {
      return this.fetchAllCategories().pipe(
        map(categories => {
          this.cachedMemoCategories = categories;
          categories.forEach(category => this.mappedMemoCategories.set(category.categoryID, category));

          return categories.sort((a, b) =>
            a.category.localeCompare(b.category, undefined, { sensitivity: 'base' })
          )
        })
      );
    } else {
      return of(this.cachedMemoCategories);
    }
  }

  fetchAllCategories(): Observable<MemoCategory[]> {
    return this._http.get<MemoCategory[]>(this.fetchAllCategoriesUrl);
  }

  setupMemoCategories(callback?: Function) {
    this.getCachedMemoCategories().subscribe(categories => {
      let filterTypes: filterSubType[] = categories.map(category => {
        return {
          name: category.category,
          memoID: 0,
          networkId: category.networkID,
          id: category.categoryID,
          value: category.categoryID,
          catShort: category.catShort
        };
      });

      Object.assign(this.store.filters.category.data, filterTypes);

      if (this.store.memos.length > 0) {
        this.populateMemoCategories()
      }
    });

    if (callback) callback();
  }

  populateMemoCategories(callback?) {

    this.store.memos = this.store.memos.map(memo => {
      let category = this.mappedMemoCategories.get(memo.Memo.categoryID);

      if (category) memo.Memo.category = category.category;
      else memo.Memo.category = 'Unknown Category';

      return memo;
    });

    this.groupMemosIntoCategoriesForResend();

  }

  groupMemosIntoCategoriesForResend() {

    this.categoryGroupsAndCount = []
    let c = this.store.filters.category.data.map((c) => {
      return c.name;
    })

    let memos = this.store.memos.filter((c) => c.Memo.sent == 1 && c.Memo.archive == 0);

    memos.forEach((m) => {
      if (c.includes(m.Memo.category)) {

        let indx = this.categoryGroupsAndCount.findIndex((e) => e.name == m.Memo.category)
        if (indx != -1) {
          this.categoryGroupsAndCount[indx].count++;
        } else {
          this.categoryGroupsAndCount.push({
            name: m.Memo.category,
            count: 1,
            // selected: this._containsSelectedMemo(m.Memo.category)
          })
        }
      }
    })

    this.store.groupMemosIntoCategories = this.store.groupMemosIntoCategories.length != 0 ? this.store.groupMemosIntoCategories : this.categoryGroupsAndCount;

    this.categoryGroupsAndCountEmitter.emit(this.store.groupMemosIntoCategories);
  }

  _containsSelectedMemo(category): boolean {
    let t = false;
    this.store.selectedForReSendMemos.forEach((m) => {
      if (m["Memo"]["category"] == category) {
        t = true;
      }
    })
    return t;
  }

  getGroupMemosIntoCategoriesForResend() {
    return this.store.groupMemosIntoCategories;
  }

  fetchMemoById(id, callback) {
    this._http.get<memoType>(this._viewMemoByIdUrl + "/" + id).subscribe((memo) => {

      memo.MemoStudentGroup = memo.MemoStudentGroup.map((student) => {
        return {
          groupID: student.groupID,
          memoID: student.memoID,
          id: student.memoID
        }
      })

      memo.MemoRecipients = memo.MemoUserLink.map(user => {
        return {
          first_name: '',
          last_name: '',
          userId: user.userID,
          email: '',
        };
      });

      this.setCurrentMemo(memo)
      callback(this.store.memo);
    })
  }

  getMemosStore() {
    return this.store.memos;
  }

  getMemoStore() {
    return this.store.memo;
  }

  getCategoriesStore() {
    return this.store.filters.category.data
  }

  // getMemoById() {
  //   if (this.store.memo) {
  //     return this.store.memo;
  //   }
  // }

  getConfirmationMessages() {

    return this.store.confirmation
  }

  // deleteConfirmMessage(messages) {
  //   this.setConfirmMessages(messages);
  // }

  setCategoriesStore(categories) {
    this.store.filters.category.data = categories
  }

  deleteCategory(categoryId: number, updatedCollection, callback) {
    this._http.post(this.deleteItemUrl + 'category.json', {
      id: categoryId
    }).subscribe(
      data => {
        // This was "this.setPriorityStore(priorities);"
        this.setCategoriesStore(updatedCollection);

        callback();
      },
      error => {

      }
    );
  }

  deleteMemo(memo, callback) {

    this._http.post(this.deleteItemUrl + 'memo.json', {
      id: memo.memoID
    }).subscribe(
      data => {
        let memoToDeleteIndex = this.store.memos.findIndex((m) => m.Memo.memoID == memo.memoID);
        if (memoToDeleteIndex != undefined) this.store.memos.splice(memoToDeleteIndex, 1);

        if (this.store.memo.Memo.memoID == memo.memoID) {
          this.resetCurrentMemo();
        }

        callback(this.store.filteredResults);
      },
      error => {
        callback(undefined);
      }
    );

  }

  archiveMemo(memo, callback, unarchive?: boolean) {
    this._http.post(this.setArchiveUrl, {
      memoId: memo.memoID,
      archive: !unarchive ? 1 : 0
    }).subscribe(
      data => {
        this.updateArchiveForMemo(memo, callback, unarchive);
      },
      error => {

      }
    );
  }

  updateArchiveForMemo(memo, callback, unarchive?: boolean) {
    if (this.store.memo.Memo.memoID == memo.memoID) {
      this.store.memo.Memo.archive = !unarchive;
    }

    this.store.memos.map((m) => {
      if (m.Memo.memoID == memo.memoID) {
        m.Memo.archive = !unarchive;
      }
    })

    if (true) callback(this.store.memos);
  }

  addCategories(payload: NewMemoCategory[], callback) {
    payload.map((e) => e.shortName = e['catShort'])
    this._http.post<MemoCategory[]>(this.createCategoriesUrl, {
      categories: payload,
    }).subscribe(
      newCategories => {
        // let addedCategoryWithDetails = {};
        callback(newCategories);
      },
      error => {

      }
    );
  }

  addPriorities(names: string[], callback) {

    let n = names.reduce((accum, curr) => {
      accum.push(curr['name'])
      return accum;
    }, [])

    this._http.post<MemoPriority[]>(this.createPrioritiesUrl, {
      priorities: n
    }).subscribe(
      newPriorities => {
        callback(newPriorities);
      },
      error => {

      }
    );
  }

  updatePriorities(priorities: MemoPriority[], callback?) {

    let prioritiesReduced = priorities.reduce((accum, curr) => {
      if (curr["id"] != 0) {
        accum.push(
          {
            priorityID: curr["id"],
            priority: curr["name"]
          }
        )
      }
      return accum;
    }, [])

    this._http.post<MemoPriority[]>(this.updatePrioritiesUrl, prioritiesReduced
    ).subscribe(success => {
    }, error => {
      callback(true)
    })
  }

  updateCategories(categories: MemoCategory[], callback?) {

    let catsReduced = categories.reduce((accum, curr) => {
      if (curr["id"] != 0) {
        accum.push(
          {
            categoryID: curr["id"],
            category: curr["name"],
            catShort: curr["catShort"]
          }
        )
      }
      return accum;
    }, [])

    this._http.post<MemoCategory[]>(this.updateCategoriesUrl, catsReduced
    ).subscribe(success => {
    }, error => {
      callback(true)
    })
  }

  saveConfirmationMessages(messages: string[], callback) {

    let flatArray = messages.reduce((accum, curr) => {
      accum.push(curr["name"])
      return accum;
    }, []);

    this._http.post(this.saveConfirmationMessagesUrl, {
      messages: flatArray.join("::")
    }).subscribe(
      success => {

        this.store.confirmation = [];
        Object.assign(this.store.confirmation, messages);
        callback();
      },
      error => {
        callback(true);
      }
    );
  }

  // addConfirmMessage(names) {
  // }

  setPriorityStore(priorities) {

    this.store.filters.priorities.data = priorities;

  }

  deletePriority(priorityId: number, updatedCollection, callback) {

    this._http.post(this.deleteItemUrl + 'priority.json', {
      id: priorityId
    }).subscribe(
      data => {
        // This was "this.setPriorityStore(priorities);"
        this.setPriorityStore(updatedCollection);

        callback();
      },
      error => {

      }
    );
  }

  saveMemo(memo: MemoTypeData, sendMemo: boolean, callback) {

   // memo.Memo['sent'] = 0; // Cheat this into the poor memo data so we can send it in proper format

    memo.Memo.email = memo.Memo.email.toString();
    memo.Memo.sent = 0;


    this._http.post<MemoTypeData>(this.saveMemoUrl, {
      Memo: memo.Memo,
      MemoCategory: memo.MemoCategory,
      MemoReferenceLink: memo.MemoReferenceLink,
      MemoPriority: memo.MemoPriority,
      MemoUserLink: memo.MemoUserLink,
      MemoStudentGroup: memo.MemoStudentGroup,
      MemoRecipients: memo.MemoRecipients,
      send: sendMemo ? 1 : 0,


    }).subscribe(
      savedMemo => {

        callback(savedMemo);

        // An almost absolute must is to replace current memo data with the memo data retrieved (Especially memoID)

      },
      error => {
        console.log("error saving this thing, do something?!")
      }
    )
  }

  resendMemos(resendData: MemoResendData, callback) {

    this._http.post(this.resendMemosUrl, resendData).subscribe(
      success => {
        callback(true)
      },
      error => {
        callback(false)
      }
    )
  }

  readMemo(memoId: number, callback: Function) {
    this._http.get<StudentMemoTypeData>(this.readMemoUrl + memoId + '.json').subscribe(
      memoData => {
        // Do something with this new memo instance?
        let studentsMemo = new memoType(memoData);

        this.setCurrentMemo(studentsMemo)
        if (callback) callback(this.store.memo);
      },
      error => {

      }
    )
  }

  acceptMemo(acceptData: MemoAcceptData, callback: Function) {
    this._http.post(this.acceptMemoUrl, acceptData).subscribe(
      success => {
        if (callback) callback(true);
      },
      error => {

      }
    )
  }

  getMemosSearchResults() {
    return this.store.searchResults;
  }

  getMemosFilters() {
    return this.store.filters;
  }

  getMemosCategories() {
    return this.store.filters.category.data
  }

  getFilteredResults() {
    return this.store.filteredResults;
  }

  setFilteredResults(data) {
    this.store.filteredResults = [];
    Object.assign(this.store.filteredResults, data);
  }

  setMemosStore(data) {
    this.store.memos = [];
    Object.assign(this.store.memos, data);
  }

  // setContentStore(data: createType) {
  //   // Object.assign(this.store.create, data);
  // }

  setCurrentMemo(memo) {

    Object.assign(this.store.memo, memo)
  }

  setCurrentMemoItems(memo, callback?) {

    //maps from model to the store... from legacy schema :(
    this.store.memo.Memo.name = memo.name || this.store.memo.Memo.name;
    this.store.memo.Memo.num = memo.num || this.store.memo.Memo.num;
    this.store.memo.Memo.numAlpha = memo.numAlpha || this.store.memo.Memo.numAlpha;
    this.store.memo.Memo.fromName = (memo.fromName == "") ? "" : memo.fromName || this.store.memo.Memo.fromName;
    this.store.memo.Memo.memoText = memo.memoText || this.store.memo.Memo.memoText;
    this.store.memo.Memo.address = memo.address || this.store.memo.Memo.address;
    this.store.memo.Memo.subject = memo.subject || this.store.memo.Memo.subject;
    this.store.memo.MemoPriority.priorityID = memo.priorityID || this.store.memo.MemoPriority.priorityID;
    this.store.memo.MemoCategory.categoryID = memo.categoryID || this.store.memo.MemoCategory.categoryID;
    this.store.memo.Memo.categoryID = memo.categoryID || this.store.memo.Memo.categoryID;
    this.store.memo.Memo.priorityID = memo.priorityID || this.store.memo.Memo.priorityID;

    this.store.memo.MemoRecipients = memo.recipients;
    this.store.memo.MemoUserLink = memo.recipients;
    this.store.memo.Memo.sent = memo.sent;

    if (memo.showMemoTitle != undefined){
      this.store.memo.Memo.showMemoTitle = memo.showMemoTitle;
    }

    this.store.memo.MemoCategory.catShort = memo.catShort || this.store.memo.MemoCategory.catShort;
    if (memo.memoId != undefined) {
      this.store.memo.Memo.memoID = memo.memoId;
      this.store.memo.Memo.id = memo.memoId;
      this.store.memo.Memo.dateCreated = memo.dateCreated;
    }

    let p = this.store.filters.priorities.data.filter((e) => e['id'] == memo.priorityID);
    this.store.memo.MemoPriority.priority = p[0] !== undefined ? p[0].name : this.store.memo.MemoPriority.priority;

    let c = this.store.filters.category.data.filter((e) => e['id'] == memo.categoryID)
    this.store.memo.MemoCategory.category = c[0] !== undefined ? c[0].name : this.store.memo.MemoCategory.category;

    this.store.memo.Memo.confirmText = memo.confirmText || this.store.memo.Memo.confirmText;

    let email;

    if (memo.email == undefined){
      email = this.store.memo.Memo.email
    }

    if (memo.email == false){
      email = "0"
    }

    this.store.memo.Memo.email = email || "1";


    if (memo.private != undefined) {
      if (typeof memo.private == "boolean") {
        this.store.memo.Memo.private = memo.private

      } else {
        this.store.memo.Memo.private = Boolean(memo.private)
      }
    }

    // this.store.memo.Memo.private = memo.private || this.store.memo.Memo.private;

    this.store.memo.Memo.declineOn = memo.declineOn || this.store.memo.Memo.declineOn;
    this.store.memo.Memo.declineText = memo.declineText || this.store.memo.Memo.declineText;
    this.store.memo.Memo.send_declined_email = memo.send_declined_email || this.store.memo.Memo.send_declined_email;

    // this.store.memo.Memo.display_time_seconds = memo.display_time_seconds || this.store.memo.Memo.display_time_seconds;

    if (memo.display_time_seconds == 0) {
      this.store.memo.Memo.display_time_seconds = 0
    } else {
      this.store.memo.Memo.display_time_seconds = memo.display_time_seconds || this.store.memo.Memo.display_time_seconds;
    }

    this.store.memo.Memo.logo = memo.logo || this.store.memo.Memo.logo;

    this.store.memo.memoVerificationQuestions = memo.questions
    if (memo.actionRequired == "") {
      this.store.memo.Memo.actionRequired = ""
    } else {
      this.store.memo.Memo.actionRequired = memo.actionRequired || this.store.memo.Memo.actionRequired;
    }

    if (memo.attachments != undefined && memo.attachments.length > 0) {

      this.store.memo.MemoReferenceLink = [];
      memo.attachments.forEach((e) => {

        this.store.memo.MemoReferenceLink.push({
          name: e.name,
          memoID: this.store.memo.Memo.memoID,
          path: (e.response) ? '/files/' + e.response.uid : e.path,
          referenceID: e.referenceID || 0
        })
      })
    } else {
      this.store.memo.MemoReferenceLink = [];
    }

    callback(this.store.memo);
  }

  getInfoText(): infoStepType {
    return this.store.currentInfoText;
  }

  getProgress(): progressType {
    return this.store.progress;
  }

  resetCurrentMemo() {
    //set defaults for current memo

    this.store.memo.Memo = defaultNewMemo.Memo;
    this.store.memo.Memo.showMemoTitle = true;
    this.store.memo.MemoReferenceLink = [];
    this.store.memo.MemoRecipients = [];
    this.store.memo.MemoUserLink = [];
    //for preview, for some reason
    this.store.memo.Memo.subject = "";
    this.store.memo.Memo.memoText = "";
    this.store.memo.Memo.name = "";
    this.store.memo.Memo.address = "";
    this.store.memo.Memo.fromName = "";
    this.store.memo.Memo.email = "1";
    this.store.memo.Memo.sent = false;
    this.store.memo.MemoPriority.priorityID = 0;

  }

}
